import "./scan-status.css";
import { isPendingScan, isRejectedScan, SCAN_FAILED_MESSAGE, SCAN_REJECTED_MESSAGE } from "../lib/scan-status.js";

/**
 * The scan state of a file, shown beside it. Renders nothing for a clean file,
 * so it can be dropped into any row unconditionally.
 */
export function ScanBadge({ file }: { file: { scanStatus?: string } }) {
  if (isPendingScan(file)) {
    return (
      <span className="scan-badge scan-badge--pending" role="status">
        Scanning…
      </span>
    );
  }
  if (isRejectedScan(file)) {
    return (
      <span className="scan-badge scan-badge--rejected" role="alert">
        {file.scanStatus === "infected" ? SCAN_REJECTED_MESSAGE : SCAN_FAILED_MESSAGE}
      </span>
    );
  }
  return null;
}
